import { render } from "./EverydayLife-2.vue?vue&type=template&id=246bea8f"
import script from "./EverydayLife-2.vue?vue&type=script&lang=js"
export * from "./EverydayLife-2.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__